import { Outlet, useNavigate } from 'react-router-dom'

import { Box, Card, Link, Text, Title } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { ChevronDown } from '@factorialco/f0-react/icons/app'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

import emptyStateTraining1 from './images/emptyStateTraining1.png'
import emptyStateTraining2 from './images/emptyStateTraining2.png'
import emptyStateTraining3 from './images/emptyStateTraining3.png'

type Props = {
  canCreate: boolean
}

const EmptyState: React.FC<Props> = ({ canCreate }) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  return (
    <>
      <Box
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s32"
        flexGrow
        padding="s24"
      >
        <Title title={i18n.t('trainings.trainings_revamp.empty_state.title')} />
        <Box width="s600">
          <Text.Normal size="300" color="grey800">
            {i18n.t('trainings.trainings_revamp.empty_state.description')}
          </Text.Normal>
        </Box>
        <Box gap="s8" flexDirection="row">
          {canCreate && (
            <>
              <F0Button
                iconName="add"
                href={navigation.trainings.list.index.new.fullPath()}
                onClick={() =>
                  track(trackingEvents.training.trainingCreationWizard.goToNewCourseWizard)
                }
                label={i18n.t('trainings.trainings_revamp.empty_state.create_training')}
              />
              <PopoverMenu type="list">
                <PopoverMenu.Trigger>
                  <F0Button
                    variant="outline"
                    icon={ChevronDown}
                    iconPosition="right"
                    label={i18n.t('trainings.trainings_revamp.empty_state.import')}
                  />
                </PopoverMenu.Trigger>
                <PopoverMenu.Content side="bottom" align="start">
                  <PopoverMenu.TouchableOption
                    title={i18n.t(
                      'trainings.trainings_revamp.empty_state.import_courses_and_participants'
                    )}
                    onClick={() => navigate(navigation.trainings.list.import.fullPath())}
                  />
                  <PopoverMenu.TouchableOption
                    title={i18n.t('trainings.trainings_revamp.empty_state.import_courses')}
                    onClick={() => navigate(navigation.trainings.list.importCourses.fullPath())}
                  />
                </PopoverMenu.Content>
              </PopoverMenu>
            </>
          )}
        </Box>
        <Box flexDirection="row" gap="s24">
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining1}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.learning_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.learning_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining2}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.monitor_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.monitor_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training_exports')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
          <Card>
            <Card.Content>
              <Box gap="s12">
                <Box padding="s12">
                  <img src={emptyStateTraining3}></img>
                </Box>
                <Text.Normal size="300" weight="semibold">
                  {i18n.t('trainings.trainings_revamp.empty_state.metrics_card.title')}
                </Text.Normal>
                <Text.Normal size="300">
                  {i18n.t('trainings.trainings_revamp.empty_state.metrics_card.description')}
                </Text.Normal>
                <Link.Router external to={helpCenterUrl('training_insights')}>
                  <Box gap="s4" justifyContent="center" alignItems="center" flexDirection="row">
                    {i18n.t('trainings.trainings_revamp.empty_state.learn_more')}{' '}
                  </Box>
                </Link.Router>
              </Box>
            </Card.Content>
          </Card>
        </Box>
      </Box>
      <Outlet />
    </>
  )
}

export default EmptyState
